<template>
    <v-form @submit.prevent="save">
        <v-row>
            <v-col cols="10" class="d-flex align-center justify-between">
                <span>
                    <v-btn variant="text" class="pa-2 btn-color" @click="$emit('listClicked')">
                        <img src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Backlog_gray.svg"
                            style="width: 16px; height: 16px" />
                        &nbsp; List
                    </v-btn>
                </span>

                <span>
                    <v-btn variant="text" class="pa-2 btn-color" @click="$emit('boardClicked')">
                        <img src=" https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Board_gray.svg "
                            style="width: 16px; height: 16px" />
                        &nbsp; Board
                    </v-btn>
                </span>

                <span>
                    <v-btn variant="text" id="more-menu-activators" class="pa-2 btn-color">
                    More..
                    <v-icon icon="mdi mdi-angle-down" size="x-small"></v-icon>
                    </v-btn>
                </span>
                <v-col cols="2" style="text-align: start;">
                    <v-label>Work Space </v-label>
                    <AutoComplete :items="workSpaceData" multiple="true" item-value="id" item-title="name"
                        density="compact" placeholder="WorkSpace" v-model="formData.workSpace"
                        @update:modelValue="getProject" :disabled="showReadOnly">
                    </AutoComplete>

                </v-col>

                <v-col cols="2" style="text-align: start;">
                    <v-label class="align-start">Account</v-label>
                    <AutoComplete :items="accountData" multiple="true" item-value="id" item-title="name"
                        density="compact" placeholder="Account" v-model="formData.account" @update:modelValue="getAcId"
                        :disabled="showReadOnly" />
                </v-col>

                <v-col cols="2" style="text-align: start;">
                    <v-label>Project</v-label>
                    <AutoComplete :items="projectData" multiple="true" item-value="id" item-title="name"
                        density="compact" placeholder="Project" v-model="formData.project"
                        @update:modelValue="getProjectId" :disabled="showReadOnly" />
                </v-col>

                <v-col cols="1" class="">
                    <v-btn color="primary" type="submit">
                        Apply
                    </v-btn>
                </v-col>

                <v-col cols="2" class="pr-0">
                    <v-text-field v-model="search" class="search-bar" label="Search" prepend-inner-icon="mdi-magnify"
                        variant="outlined" density="compact" hide-details @input="onSearch"></v-text-field>
                </v-col>
            </v-col>
        </v-row>
         <MenuOptions v-on:menuSelected="(value) => {
                selectedMore = value;
                $emit('more', value);
            }
            " :options="moreMenuOptions" activator="#more-menu-activators" />
    </v-form>

</template>
<script>
import WorkSpaceService from '@/api/service/WorkSpace/WorkSpaceService';
import AutoComplete from '../../components/ui/AutoComplete.vue'
import ProjectService from '@/api/service/Project/ProjectService';
import AccountService from '@/api/service/Account/AccountService';
import IssueService from '@/api/service/Issue/IssueService';
import MenuOptions from "@/menus/MenuOptions.vue";

export default {
    components: {
        AutoComplete,
        MenuOptions
    },
  props: ["defaultSort", "defaultGroup", "resetFilter", "zeroBoardIssues", "displayType", "assignedToMe", "unAssigned"],
    data() {
        return {
            selectedMore: { title: "Bulk Update", value: "created" },
            moreMenuOptions: [
                { title: "Bulk Update", value: "bulkUpdate" },
                { title: "Bulk Update Oneline Comment", value: "uploadcomment" },
                { title: "Export as Excel", value: "export" },
            ],
            backupMoreMenuOptions: [
                { title: "Bulk Update", value: "bulkUpdate" },
                { title: "Bulk Update Oneline Comment", value: "uploadcomment" },
                { title: "Export as Excel", value: "export" },
            ],
            search: '',
            workSpaceData: [],
            projectData: [],
            accountData: [],
            workSpaceIds: [],
            projectIds: [],
            acId: [],
            selectAllActive: false,
            wsSelectAllActive: false,
            projectSelectAllActive: false,
            accountSelectAllActive: false,
            formData: {
                workSpace: [],
                project: [],
                account: [],

            }
        }
    },

    watch: {
        workSpace(newValue, oldValue) {
            console.log('Message changed from !!', oldValue, 'to', newValue)
        },

        displayType() {
            if (this.displayType && this.displayType == 'list') {
                let index = this.moreMenuOptions.findIndex(k => k.value == 'UNA')
                if (index == -1) {
                this.moreMenuOptions = this.backupMoreMenuOptions
                this.moreMenuOptions.push(
                    { title: "Update Next Action", value: "UNA" },
                    // { title: "Stage", value: "stage" }
                )
                }
            }

            else {
                this.moreMenuOptions = this.backupMoreMenuOptions
            }
        }
    },

    async created(){
        this.getAllQaDatas()
        let defaltGroup = localStorage.getItem("_DEFAULTS_")
        this.selectedGroup = defaltGroup ? JSON.parse(defaltGroup).group : this.selectedGroup
        /*  if(this.defaultGroup.title) {
                this.selectedGroup = this.defaultGroup
            }
            if(this.defaultSort.title) {
                this.selectedSort= this.defaultSort
            } */
        let wsDetails = localStorage.getItem("_WS_DEFAULTS_")
        wsDetails = wsDetails ? JSON.parse(wsDetails):{}
        await this.getAccessNextAction(wsDetails)
        // console.log(this.displayType,"displayType dataaaaaaaaaa",this.showNextAction);
        if (this.displayType && this.displayType == 'list') {
        let index = this.moreMenuOptions.findIndex(k => k.value == 'UNA')
            if (index == -1) {
            this.moreMenuOptions = this.backupMoreMenuOptions
            this.moreMenuOptions.push(
                { title: "Update Next Action", value: "UNA" },
            )
            }
        }
        else {
        this.moreMenuOptions = this.backupMoreMenuOptions
        }
    },

    mounted() {
        this.getWorkSpace()
    },

    methods: {
        async getAccessNextAction(data) {
            try{
                    let userData = localStorage.getItem('user_details')
                    userData = userData ? JSON.parse(userData) : {}
                    let res = await WorkSpaceService.getAccessNextAction({
                    workSpaceId: data && data.workspace && data.workspace.id?data.workspace.id:null,
                    roleId: userData && userData.roles && userData.roles.id ? userData.roles.id : null
                    })
                    this.showNextAction = res && res.length>0?true:false
                    return this.showNextAction
            }
            catch(e){
                console.log(e);
                return  this.showNextAction
            }

        },
        async getAllQaDatas(){
                let getFilteredData = await IssueService.findAllIssues(
                    {
                        // work_space_id: this.workSpaceIds,
                        // project_id: this.projectIds,
                        // account_id: this.acId,
                        qcBoardAll: 1
                    })
                this.$emit('filter-data',getFilteredData)
                // alert('after emit')
                console.log(getFilteredData, "filll");
        },
         onSearch() {
            this.$emit("search-changed", this.search);
            },
        async save() {
            console.log(this.workSpaceIds, "acacac", this.projectIds);
            console.log(this.workSpaceIds, 'save', this.projectIds, 'save', this.acId)
            // if (this.workSpaceIds.length == 0) {
            //     alert(1)
            //     let getFilteredData = await IssueService.findAllIssues(
            //         {
            //             // work_space_id: this.workSpaceIds,
            //             // project_id: this.projectIds,
            //             // account_id: this.acId,
            //             qcBoardAll: a11
            //         })
            //     this.$emit('filter-data',getFilteredData)
            //     // alert('after emit')
            //     console.log(getFilteredData, "filll");
            // }
            // else {
                let getFilteredData = await IssueService.findAllIssues(
                    {
                        work_space_id: this.workSpaceIds,
                        project_id: this.projectIds,
                        account_id: this.acId,
                        qc: 1
                    })
                this.$emit('filter-data',getFilteredData)
                //  alert('after emit')
                console.log(getFilteredData, "filll");
            // }
        },
        async getWorkSpace() {
            try {
                let workSpace = await WorkSpaceService.getWorkSpaceByUser({ active: 1 })
                if (workSpace.length > 0) {
                    this.workSpaceData = [{ id: 0, name: 'Select All', account_id: [0], project_id: [0] }, ...workSpace]
                    console.log(this.workSpaceData, "this.workSpaceData")
                }
                else {
                    this.workSpaceData = []
                }
            } catch (error) {
                this.workSpaceData = [];
                console.log(error, 'error');
            }
        },

        async getProject(val) {
            try {
                this.projectIds = [];
                this.projectData = [];
                this.acId = [];
                this.accountData = [];
                this.wsError = false;

                // --- Start of New Logic ---
                const selectAllWasActive = this.wsSelectAllActive;
                const selectAllIsActive = val.includes(0);
                let newSelection = [];

                if (selectAllIsActive && !selectAllWasActive) {
                    // Case 1: "Select All" was just turned ON.
                    // Select everything.
                    newSelection = this.workSpaceData.map(item => item.id);
                    this.wsSelectAllActive = true;
                } else if (!selectAllIsActive && selectAllWasActive) {
                    // Case 2: "Select All" was just turned OFF.
                    // Unselect everything.
                    newSelection = [];
                    this.wsSelectAllActive = false;
                } else if (selectAllIsActive && val.length < this.workSpaceData.length) {
                    // Case 3: "Select All" is ON, but user unselected an individual item.
                    // Unselect "Select All" and keep the rest.
                    newSelection = val.filter(id => id !== 0);
                    this.wsSelectAllActive = false;
                } else if (!selectAllIsActive && this.workSpaceData.length > 1 && val.length === this.workSpaceData.length - 1) {
                    // Case 4: User manually selected all items *except* "Select All".
                    // We should also select "Select All".
                    newSelection = this.workSpaceData.map(item => item.id);
                    this.wsSelectAllActive = true;
                } else {
                    // Case 5: Normal individual selection or initial state.
                    newSelection = val;
                }

                // This is the key: force update the v-model.
                this.formData.workSpace = [];
                this.$nextTick(() => {
                    this.formData.workSpace = newSelection;
                });
                // --- End of New Logic ---

                const wsIds = newSelection.filter(id => id !== 0);
                this.workSpaceIds = wsIds;

                if (wsIds.length > 0) {
                    await this.getProj(wsIds);

                    this.acId = [];
                    for (let i of this.workSpaceData.filter(ws => wsIds.includes(ws.id))) {
                        let parsed = i.account_id;
                        if (typeof parsed === "string") parsed = JSON.parse(parsed);
                        if (Array.isArray(parsed)) this.acId.push(...parsed);
                        else this.acId.push(parsed);
                    }
                    await this.getAccount(this.acId);
                } else {
                    this.projectData = [];
                    this.accountData = [];
                }

            } catch (e) {
                console.log(e);
            }
        },
        async getProjectId(project) {
            // --- Start of New Logic ---
            const selectAllWasActive = this.projectSelectAllActive;
            const selectAllIsActive = project.includes(0);
            let newSelection = [];

            if (selectAllIsActive && !selectAllWasActive) {
                // Case 1: "Select All" was just turned ON.
                newSelection = this.projectData.map(item => item.id);
                this.projectSelectAllActive = true;
            } else if (!selectAllIsActive && selectAllWasActive) {
                // Case 2: "Select All" was just turned OFF.
                newSelection = [];
                this.projectSelectAllActive = false;
            } else if (selectAllIsActive && project.length < this.projectData.length) {
                // Case 3: "Select All" is ON, but user unselected an individual item.
                newSelection = project.filter(id => id !== 0);
                this.projectSelectAllActive = false;
            } else if (!selectAllIsActive && this.projectData.length > 1 && project.length === this.projectData.length - 1) {
                // Case 4: User manually selected all items *except* "Select All".
                newSelection = this.projectData.map(item => item.id);
                this.projectSelectAllActive = true;
            } else {
                // Case 5: Normal individual selection.
                newSelection = project;
            }

            // Force update v-model
            this.formData.project = [];
            this.$nextTick(() => {
                this.formData.project = newSelection;
            });
            // --- End of New Logic ---

            this.projectIds = newSelection.filter(id => id !== 0);
            console.log(this.projectIds, "final project ids");
        },
        async getAcId(account) {
            // --- Start of New Logic ---
            const selectAllWasActive = this.accountSelectAllActive;
            const selectAllIsActive = account.includes(0);
            let newSelection = [];

            if (selectAllIsActive && !selectAllWasActive) {
                // Case 1: "Select All" was just turned ON.
                newSelection = this.accountData.map(item => item.id);
                this.accountSelectAllActive = true;
            } else if (!selectAllIsActive && selectAllWasActive) {
                // Case 2: "Select All" was just turned OFF.
                newSelection = [];
                this.accountSelectAllActive = false;
            } else if (selectAllIsActive && account.length < this.accountData.length) {
                // Case 3: "Select All" is ON, but user unselected an individual item.
                newSelection = account.filter(id => id !== 0);
                this.accountSelectAllActive = false;
            } else if (!selectAllIsActive && this.accountData.length > 1 && account.length === this.accountData.length - 1) {
                // Case 4: User manually selected all items *except* "Select All".
                newSelection = this.accountData.map(item => item.id);
                this.accountSelectAllActive = true;
            } else {
                // Case 5: Normal individual selection.
                newSelection = account;
            }

            // Force update v-model
            this.formData.account = [];
            this.$nextTick(() => {
                this.formData.account = newSelection;
            });
            // --- End of New Logic ---

            this.acId = newSelection.filter(id => id !== 0);
            console.log(this.acId, "final account ids");
        },
        async getProj(workSpaceIds) {
            await ProjectService.getWorkSpaceProject({ work_space_id: workSpaceIds.join(",") }).then((response) => {
                this.projectData = response && response.length > 0 ? [{ id: 0, name: 'Select All' }, ...response] : []
                console.log(this.projectData, ' this.projectData!!')
            }).catch(e => {
                console.log(e)
            }
            )
        },

        async getAccount(acId) {
            await AccountService.getAccountNamesByID({ accountId: acId.join(",") }).then((response) => {
                this.accountData = response && response.length > 0 ? [{ id: 0, name: 'Select All' }, ...response] : []
                console.log(this.accountData, 'account!!')
            }).catch(e => {
                console.log(e)
            })
        },

    }
}
</script>
<style scoped></style>